module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "admin-cian-arow-drag-icon.4ed98175.svg";